import React from 'react';
import './App.css';
import TopBar from './components/top-bar';
import OptionTabs from './components/tabs';

function App() {

  return (
    <div className='w-100'>
      <TopBar />
      <OptionTabs />
    </div>

  );
}

export default App;
